import React, { useState } from "react";
import { X } from "lucide-react";

export default function RejectModal({ richiesta, onClose, onConfirm }) {
  const [note, setNote] = useState("");
  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-md shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between p-4 border-b border-slate-200">
          <h2 className="font-display text-lg font-bold text-rose-700">Rifiuta richiesta</h2>
          <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-4">
          <p className="text-sm text-slate-600 mb-3">
            Fornisci una motivazione al lavoratore (opzionale ma consigliata).
          </p>
          <textarea
            rows={3}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className="w-full px-3 py-2 border border-slate-300 rounded-sm text-sm"
            placeholder="Motivazione del rifiuto…"
            data-testid="reject-motivazione"
          />
        </div>
        <div className="flex justify-end gap-2 p-4 border-t border-slate-200 bg-slate-50">
          <button onClick={onClose} className="px-4 py-2 text-sm font-semibold border border-slate-300 rounded-sm hover:bg-white">Annulla</button>
          <button
            onClick={() => onConfirm(note)}
            data-testid="btn-confirm-reject"
            className="px-4 py-2 text-sm font-semibold bg-rose-600 hover:bg-rose-700 text-white rounded-sm"
          >
            Conferma rifiuto
          </button>
        </div>
      </div>
    </div>
  );
}
